import React from 'react';
import CONSTANTS from '../../../constants';

const AutopayContent = () => {
  return (
    <div id="autopay">
      <div className="top">
        <div className="area">
          <img src="https://img.dongascience.com/air/autopay/autopay_top.png" alt="정기결제 런칭기념 이벤트-매월 찾아오는 과학 지식의 즐거움 20%할인" />
        </div>
      </div>
      <div className="intro">
        <div className="area">
          <img src="https://img.dongascience.com/air/autopay/autopay_intro.png" alt="이제 정기결제로 더 편리하게 이용하세요!" />
          <button 
            type="button"
            style={{
              border: 'none',
              background: 'transparent',
              padding: 0,
              cursor: 'pointer'
            }}
            onClick={() => {
              window.open(CONSTANTS.D_LIBRARY_SUBSCRIPTION_PAYMENT, '_blank');
            }}
          >
            <img src="https://img.dongascience.com/air/autopay/autopay_intro_btn.png" alt="자동 정기결제로 ALL 패스권 특가 신청하기" />
          </button>
        </div>
      </div>
      <div className="info01">
        <div className="area">
          <img src="https://img.dongascience.com/air/autopay/autopay_info01.png" alt="과학동아AiR 강점" />
        </div>
      </div>
      <div className="info02">
        <div className="area">
          <img src="https://img.dongascience.com/air/autopay/autopay_info02.png" alt="과학동아AiR 활용방법" />
        </div>
      </div>
      <div className="price">
        <div className="area">
          <img src="https://img.dongascience.com/air/autopay/autopay_price.png" alt="20% 초특가 할인" />
          <button 
            type="button"
            style={{
              border: 'none',
              background: 'transparent',
              padding: 0,
              cursor: 'pointer'
            }}
            onClick={() => {
              window.open(CONSTANTS.D_LIBRARY_SUBSCRIPTION_PAYMENT, '_blank');
            }}
          >
            <img src="https://img.dongascience.com/air/autopay/autopay_intro_btn.png" alt="자동 정기결제로 ALL 패스권 특가 신청하기" />
          </button>
        </div>
      </div>
      <div className="cs">
        <div className="area">
          <img src="https://img.dongascience.com/air/autopay/autopay_cs.png" alt="유의사항" />
        </div>
      </div>
    </div>
  );
};

export default AutopayContent;
